import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Bookofjohn() {

  return (
    <>
        <Container>
            <Row>
                <Col sm={12} md={6} lg={6} xl={6}>
                    <p className="text">
                    <span className="quotationMark">&ldquo;</span>
                        For God so loved the world that he gave his only begotten Son,
                    </p>
                    <p className="text offsetText">
                        that whosoever believeth in him should not perish, but have eternal life
                        <span className="quotationMark2">&rdquo;</span>
                    </p>
                    <p className="offsetText">
                        <b>John 3:16</b>
                    </p>
                </Col>
            </Row>
        </Container>
    </>
  )

}

export default Bookofjohn